RivalIQ.apps.Admin.apps.Account.module('views', function (views, App, Backbone, Marionette, $, _, async) {

    'use strict';

    views.Users = Marionette.LayoutView.extend({
        template: '#adminUserTemplate',
        regions: {
            results: '#searchResults'
        },

        ui: {
            searchInput: '.x-user-search',
            formGroup: '#adminUserFormGroup',
            errorLabel: '#adminErrorLabel',
            createUserBtn: '.btn-create-user'
        },

        events: {
            'input @ui.searchInput': 'search',
            'click @ui.createUserBtn': 'createUser'
        },

        eventsNotToDebounce: {
            'keydown @ui.searchInput': 'onSearchKeydown'
        },

        initialize: function () {
            const me = this;
            me.listenTo(App, 'account:edit:complete', me.accountEditComplete);
            me.listenTo(App, 'account:create:complete', me.accountEditComplete);
        },

        onShow: function () {
            const me = this;
            me.ui.searchInput.focus();
        },

        accountEditComplete: function () {
            // on edit success or error, refresh the collection so that a subsequent edit of the same account is more likely to succeed.
            const me = this;
            me.search(true);
        },

        showResults: function () {
            const me = this;

            me.results.show(new views.UserSearchResults({
                collection: me.collection,
                adminEditingProperties: me.options.adminEditingProperties
            }));
        },

        onSearchKeydown: function (e) {
            const me = this;

            if (e.keyCode === 13) {
                e.preventDefault();
                me.search();
            }
        },

        createUser: function () {
            const me = this;

            RivalIQ.execute('show:modal', new views.Edit({
                model: new RivalIQ.apps.Admin.models.User({
                    first_name: null,
                    last_name: null,
                    email: null,
                    account_user_status_id: _(RivalIQ.enums.user.status.registration).value(),
                    status: RivalIQ.enums.account.status.REGISTRATION,
                    account: {
                        settings: {
                            selfChurned: false
                        },
                        plan_id: 9,
                        plan_overrides: {},
                        admin_created: true
                    }
                }),
                selectorProperties: me.options.adminEditingProperties,
                refreshAfterSave: false
            }));
        },

        search: function (force) {
            const me = this;

            const query = $.trim(me.ui.searchInput.val()).toLowerCase();

            if (!query) {
                me.collection.reset([]);
                return;
            } else if (query === me.previousSearch && !force) {
                return;
            }

            me.results.showLoading();

            const deferred = async.callbackToDeferred(function (error) {

                if (error) {
                    switch (error.status) {
                        case 0:
                            return;
                        default:
                        // Reset previous search to allow retry
                            me.previousSearch = '';
                            return me.results.showError();
                    }
                }

                me.showResults();
            });

            me.previousSearch = query;

            me.collection.query = query;
            me.collection.fetch({
                data: {
                    query: query,
                    limit: 50
                }
            }).done(deferred.resolve).fail(deferred.reject);
        }
    });
}, RivalIQ.utils.async);
